<template>
  <transition name="slide-fade">
    <default-layout>
      <v-app v-if="mounted">
        <v-app-bar app elevate-on-scroll color="black" dark :shrink-on-scroll="!authType" src="/images/myriam-zilles-KltoLK6Mk-g-unsplash.jpg" :bottom="$breakpoint.smAndDown" id="myheader">
          <template v-slot:img="{ props }">
            <v-img
              v-bind="props"
              gradient="to top right, rgba(19,84,22,.9), rgba(12,20,19,.8)"
            ></v-img>
          </template>
          <!-- <v-app-bar-nav-icon @click="drawer = !drawer" class="hidden"></v-app-bar-nav-icon> -->
          <v-toolbar-title role="button" @click="goTo('/?redirect=' + route().current())" title="Home">
            <v-img src="/maskable_icon_x512.png" width="45px" height="45px"></v-img>
          </v-toolbar-title>
          <v-toolbar-items v-if="can && can['dashboard.view']">
            <v-btn :icon="$vuetify.breakpoint.xsOnly" class="" text href="/dashboard" title="Dashboard" @click.stop.prevent="goTo('/dashboard')">
              <span v-if="$vuetify.breakpoint.xsOnly">
                <v-icon>dashboard</v-icon>
              </span>
              <span v-else>Dashboard</span>
            </v-btn>
          </v-toolbar-items>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn small href="/service_requests/create" title="Request service" :icon="$breakpoint.xsOnly" :fab="$breakpoint.xsOnly" text @click.stop.prevent="goTo('/service_requests/create')">
              <v-icon :left="!$breakpoint.xsOnly">mdi-thermometer-plus</v-icon><span v-if="!$breakpoint.xsOnly">Request</span>
            </v-btn>
          </v-toolbar-items>
          <v-spacer></v-spacer>
          <v-toolbar-items v-show="$notifications.length > 0">
            <v-btn icon @click="goTo('/user/notifications?open_type=list')" title="Notifications">
              <v-badge :content="$notifications.length" :value="$notifications.length" color="green" overlap>
                <v-icon>
                  mdi-bell
                </v-icon>
              </v-badge>
            </v-btn>
          </v-toolbar-items>
          <v-toolbar-items class="px-1" v-if="$breakpoint.smAndUp">
            <v-btn @click="_changeMode()" text small icon title="Toggle Dark Mode">
              <v-icon>mdi-theme-light-dark</v-icon>
            </v-btn>
          </v-toolbar-items>
          <v-toolbar-items v-if="$page.props.user">
            <v-menu bottom left offset-y :close-on-content-click="false" transition="fab-transition" :origin="$breakpoint.smAndDown ? 'bottom right' : 'top right'" title="User menu">
              <template v-slot:activator="{ on, attrs }">
                <v-btn fab v-bind="attrs" v-on="on" small title="User menu">
                  <v-avatar style="border: 1px solid;"><v-img :src="$user.profile_photo_url" lazy-src="/images/user.gif" alt="user profile photo"></v-img></v-avatar>
                </v-btn>
                <!-- <v-btn :icon="$breakpoint.xsOnly" v-bind="attrs" v-on="on" text id="mybutton" title="User menu">
                  <v-icon :left="!$breakpoint.xsOnly">mdi-account-cog-outline</v-icon>
                  <span v-if="!$breakpoint.xsOnly" class="long-button-text">{{ $page.props.user.name }}</span>
                </v-btn> -->
              </template>
              <user-menu></user-menu>
            </v-menu>
          </v-toolbar-items>
          <v-toolbar-items v-else>
            <v-menu bottom left :close-on-content-click="false" transition="fab-transition" :origin="$breakpoint.smAndDown ? 'bottom right' : 'top right'" title="Login / Register">
              <template v-slot:activator="{ on, attrs }">
                <v-btn v-bind="attrs" v-on="on" text id="mybutton" x-small title="Login / Register">
                  <v-icon left>mdi-account</v-icon> <span class="long-button-text">Login Register</span>
                </v-btn>
              </template>
              <guest-menu></guest-menu>
            </v-menu>
          </v-toolbar-items>
        </v-app-bar>
        <v-main id="maincontent">
          <message-bar></message-bar>
          <transition name="slide-fade" mode="out-in">
            <slot></slot>
          </transition>
          <v-snackbar :value="cookiesConsent" multi-line vertical :timeout="-1" color="deep-purple darken-4" elevation="24">
            <p>This Primacy Health website uses cookies to enhance the user experience. Furthermore, cookies are required to be able to log in to your account.</p>
            <p>In order to understand more, please read the our <a class="white--text" href="/privacy-policy"><i>privacy policy</i></a>. By continuing to use this site, you consent to the use of cookies</p>
            <template v-slot:action="{ attrs }">
              <v-btn color="" text v-bind="attrs" @click="AcceptCookies">
                Accept
              </v-btn>
              <v-btn color="orange" text v-bind="attrs" @click="declineConsent">
                Decline
              </v-btn>
            </template>
          </v-snackbar>
          <v-snackbar v-model="snackbar" :timeout="timeout" bottom :color="color">
            <span v-html="message"></span>
          </v-snackbar>
          <v-snackbar v-model="loginerror" :timeout="20000" bottom elevation="24" dark>
            <span>Login failed. Go to <a href="/login">Login Page</a></span>
            <template v-slot:action="{ attrs }">
              <v-btn color="error" text v-bind="attrs" @click="loginerror = false" small outlined>
                Close
              </v-btn>
            </template>
          </v-snackbar>
          <PermissionForNotifications v-if="$user && $user.id"></PermissionForNotifications>
          <mk-dialog v-model="twofactor" persistent>
            <template #title>Enter 2-Factor Authentication Code</template>
            <two-factor-component v-if="twofactor" dialog-mode></two-factor-component>
          </mk-dialog>
        </v-main>
      </v-app>
    </default-layout>
  </transition>
</template>

<script>
  import PermissionForNotifications from '@/Mixins/PermissionForNotification'
  import UserMenu from '@/Components/components/user-menu'
  import GuestMenu from '@/Components/components/guest-menu'
  import DefaultLayout from '@/Layouts/Default'
  import Vue from 'vue'
  import VueCookie from 'vue-cookie'
  const MessageBar = async () => await import(/* webpackMode: 'lazy' */ /* webpackChunkName: "main-components" */ '@/Components/components/messagebar')
  const MkDialog = async () => await import(/* webpackMode: 'lazy' */ /* webpackChunkName: "main-components" */ '@/Components/components/mk-dialog')
  const TwoFactorComponent = async () => await import(/* webpackMode: 'lazy' */ /* webpackChunkName: "main-components" */ '@/Pages/Auth/2fa')

Vue.use(VueCookie)

  export default {
    name: 'guest-layout',
    components: {
      MkDialog,
      UserMenu,
      GuestMenu,
      MessageBar,
      DefaultLayout,
      TwoFactorComponent,
      PermissionForNotifications,
    },
    metaInfo () {
      return {
        title: 'Welcome',
        titleTemplate: '%s | ' + this.$title
      }
    },
    props: [
      'user'
    ],
    data () {
      return {
        drawer: true,
        cookiesConsent: false,
        snackbar: false,
        message: '',
        mounted: false,
        twofactor: false,
        timeout: 2000,
        color: 'light-blue',
        loginerror: false,
      }
    },
    methods: {
      logout () {
        this.$cookie.set('loggedout', true, { expires: '1D' })
        this.$inertia.post('/logout')
      },
      getprofile () {
        this.$inertia.visit('/user/profile')
      },
      goToLink (url) {
        this.$inertia.visit(url)
      },
      reloadCurrent () {
        this.$inertia.reload({ preserveScroll: true, preserveState: false })
      },
      checkCookiesPolicy () {
        let accepted = this.$cookie.get('accepted_cookies')
        if (!accepted) {
          this.cookiesConsent = true
        }
      },
      AcceptCookies () {
        let today = this.moment()
        this.$cookie.set('accepted_cookies', today, { expires: '1Y'})
        this.cookiesConsent = false
      },
      declineConsent () {
        location.replace('about:blank')
      },
      attemptLogin () {
        let vm = this
        this.snackbar = false
        this.message = 'Attempting Login ....'
        this.snackbar = true
        this._getUser()
        .then(res => {
          this.message = 'You are logged in'
          this.snackbar = false
          setTimeout(() => {
            vm.snackbar = true
          }, 500)
        })
        .catch(err => {
          this.message = 'Login failed'
          this.loginerror = false
          setTimeout(() => {
            vm.loginerror = true
          }, 500)
        })
        // setTimeout(() => {
        //   let user = vm.$user
        //   vm.snackbar = false
        //   setTimeout(() => {
        //     vm.snackbar = true
        //     vm.message = user ? 'You are logged in' : 'Login failed'
        //   }, 500)
        // },5000)
      },
    },
    mounted () {
      this.$nextTick(() => {
        this.mounted = true
        this.checkCookiesPolicy()
        // const element = document.querySelector("iframe");
        // // console.log(element)
        // if (element) {
        //   element.remove()
        // }
        window.addEventListener('loginresponse', function (e) {
          var url = e.detail.url
          if (url) {
            var path = '/two-factor-challenge'
            var index = url.indexOf(path)
            if (index > -1) {
              // swal({
              //   title: '',
              //   text: 'Please enter your authentication code to complete the login',
              //   type: 'warning',
              //   showCancelButton: true,
              //   confirmButtonColor: 'lightblue',
              //   confirmButtonText:'Enter Code',
              //   cancelButtonText: 'Later',
              //   allowOutsideClick: true,
              // },
              // function () {
              //   this.twofactor = true
              // //   this.goTo(path)
              // }.bind(this))
              this.twofactor = true
            } else {
              this.message = 'Attempting login ...'
              this.snackbar = true
              this.cookiesConsent = false

              if (window.location.pathname == '/login') {
                this.$inertia.reload()
                setTimeout(() => {
                  this.goTo(url)
                }, 500)
              } else {
                this.goTo(url)
                this.$inertia.reload({ preserveScroll: true, preserveState: false })
              }
              this.attemptLogin()
            }
          } else {
            this.message = 'Attempting login ...'
            this.snackbar = true
            this.attemptLogin()
            // this.$inertia.reload({ preserveScroll: true, preserveState: false })
          }
        }.bind(this))
        window.addEventListener('loginerror', function (e) {
          console.error(e);
          console.warn('Login failed', e);
          this.loginerror = true
        }.bind(this))
      })
    },
    unMounted () {
      window.removeEventListener('loginresponse')
      window.removeEventListener('loginerror')
    },
    computed: {
      authType () {
        var type = this.$page.props.page_type
        if (type || this.$breakpoint.xsOnly) {
          return true
        } else {
          return false
        }
      }
    }
  }
</script>

<style>
  .long-button-text {
    white-space: normal;
    width: 80px;
    padding-right: 0px;
  }
  .hidden {
    display: none;
  }
  [role="button"] {
    cursor: pointer;
  }
  @media screen and (min-width: 703px) {
    .v-dialog:not(.v-dialog--fullscreen) {
      max-width: 60vw;
    }
  }
  .v-dialog > .v-card > .v-card__text {
    padding: 1px;
  }
  .v-dialog {
    margin: 5px;
  }
  .v-card__title.primary {
    color: white;
  }
  .border-primary, .v-card .primary {
    border: 1px solid var(--v-primary-base) !important;
  }
</style>
